module.exports = __webpack_public_path__ + "img/minus.b95e2c7a.svg";